import React from 'react';
import './BlockPersonalSpace.scss';
import './BlockPersonalSpace-media.scss';
import { MediaContent } from '../../services/GlobalFunctions';
import { Props } from './interfaces';

const BlockPersonalSpace = ({ content }: Props) => {
  const images = (
    <>
      <span className="block-personal-space__iphone"></span>
      <span className="block-personal-space__macbook"></span>
    </>
  );

  return (
    <div className="block-personal-space">
      <div className="block-personal-space__bg"></div>
      <div className="block-personal-space__description">{content}</div>
      {MediaContent(images, <div className="block-personal-space__images-mob">{images}</div>)}
    </div>
  );
};

export default BlockPersonalSpace;
